import { FeedbackChallenge } from './feedback-challenge.interface';
import { Feedback } from './feedback.interface';

export interface FeedbackByCompany {
  feedbackApp?: Feedback;
  feedbackFacilitator?: Feedback;
  feedbackChallenges?: FeedbackChallenge[];
}
